(() => {
  const el = document.getElementById("yun9-preload-urls");
  if (!el) return;

  let urls = [];
  try { urls = JSON.parse(el.textContent || "[]"); } catch (e) { return; }
  if (!urls.length) return;

  const conn = navigator.connection;
  const slow = conn && (conn.saveData || /2g/.test(conn.effectiveType));
  if (slow) return;

  const warm = () => {
    urls.forEach((u) => {
      const img = new Image();
      img.decoding = "async";
      img.loading = "eager";
      img.src = u;
    });
  };

  if ("requestIdleCallback" in window) {
    requestIdleCallback(warm, { timeout: 1500 });
  } else {
    setTimeout(warm, 800);
  }
})();
